import { HttpService } from '../http.service'
import { API_PAYROLL, ENV } from '../../env'
import { useUserStore } from '@/store/user'
import { getBankOptions } from '../bank-templates'

export type BankFileStatus = 'generated' | 'failed' | 'expired'

export interface BankFile {
  id: string
  closedPayrollId: string
  templateId: string
  companyAccountId: string
  s3Key: string | null
  format: 'TXT' | 'CSV' | 'EXCEL'
  status: BankFileStatus
  totalTransactions: number
  totalAmount: number
  generatedAt: string
  isDeleted: boolean
  error: string | null
}

export interface BankFileDownload {
  id: string
  fileName: string
  format: string
  downloadUrl: string
}

/* GET documents/bank-templates: solo los campos que se usan aqui */
interface BankTemplateSummary {
  bankTemplateId: string
  name: string
  originBankId: string
}

/* API GW del nuevo modulo de payroll (servicio de documentos / entregables). */
const httpPayroll = new HttpService(API_PAYROLL[ENV()]())

const payrollHeaders = () => ({
  'x-workspace-id': useUserStore().user?.workspaceId ?? ''
})

export async function listBankFiles(
  closedPayrollId: string,
  includeDeleted = false
): Promise<BankFile[]> {
  const response = await httpPayroll.get<BankFile[]>('documents/bank-files', {
    params: { closedPayrollId, includeDeleted },
    headers: payrollHeaders()
  })
  return response.data
}

/* La URL es prefirmada y caduca en minutos: se pide en el momento de descargar */
export async function getBankFileDownload(
  bankFileId: string
): Promise<BankFileDownload> {
  const response = await httpPayroll.get<BankFileDownload>(
    `documents/bank-files/${bankFileId}/download`,
    { headers: payrollHeaders() }
  )
  return response.data
}

/**
 * Resuelve cada plantilla a la entidad destinataria del entregable (hoy el
 * banco origen; a futuro puede ser un ente de gobierno u otro destinatario).
 * Si el banco no esta en el catalogo se cae al nombre de la plantilla.
 */
export async function getBankTemplateEntities(): Promise<Map<string, string>> {
  const [response, banks] = await Promise.all([
    httpPayroll.get<BankTemplateSummary[]>('documents/bank-templates', {
      headers: payrollHeaders()
    }),
    getBankOptions()
  ])
  const bankNames = new Map(banks.map(bank => [bank.id, bank.name]))
  return new Map(
    (response.data ?? []).map(template => [
      template.bankTemplateId,
      bankNames.get(template.originBankId) ?? template.name
    ])
  )
}
